import { render, staticRenderFns } from "./Building.global.vue?vue&type=template&id=2ad5ce00&scoped=true&lang=pug&"
import script from "./Building.global.vue?vue&type=script&lang=ts&"
export * from "./Building.global.vue?vue&type=script&lang=ts&"
import style0 from "./Building.global.vue?vue&type=style&index=0&id=2ad5ce00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad5ce00",
  null
  
)

export default component.exports